import styled from 'styled-components';
import slide1 from 'assets/images/mobile/slide1.jpg';
import { fonts } from 'styles';

export const Container = styled.section`
  width: 100%;
  min-height: 100vh;
`;

export const Image = styled.img.attrs({ src: slide1 })`
  width: 100%;
`;

export const HeadlineWrapper = styled.div`
  width: 100%;
  padding: 56px 56px 32px 56px;
`;
export const Content = styled.div`
  width: 100%;
  padding: 56px;
`;

export const Headline = styled.h1`
  font-family: ${fonts.BentonSansWideBlack};
  font-size: 33px;
  line-height: 36px;
  text-transform: uppercase;
  color: #fff;
`;

export const Text = styled.article`
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.5px;
  color: #fff;
  margin-bottom: 32px;
`;

export const Caption = styled.div`
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #fff;
  margin-bottom: 56px;

  span {
    font-family: ${fonts.BentonSansBold};
  }
`;

export const Subtitle = styled.div`
  font-size: 14px;
  line-height: 18px;
  color: #fff;
`;
